import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  parentIndex: number;
}

export default function VisaTable(props: Props) {
  const { t } = useTranslation();
  const name: any = `approvalable.documentPurchases.${props.parentIndex}.documentPurchaseGuests`;
  const _values = HOCWatchValue({ keys: [name] });
  const data = _values[name];

  const columns = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('document:document_type'),
      accessorKey: 'documentPurchaseGuestVisaTypes',
      minSize: 250,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
      maxTags: 2,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={data}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
